import { memo, ReactElement } from 'react';
import { UpgradeModule } from '../components/UpgradeModule';
import { CurrentHealthContainer, HealthContainer } from './styles';
import { HealthUnitsInfo } from './components/UnitsInfo';
import { HealthHistoryCard } from './HistoryCard';
import { useFilterContext } from '../contexts/FilterContext';
import { HealthMap } from './Map';

interface HealthProps {
  order: number;
  hasHealth: boolean;
  loading: boolean;
}

function HealthComponent({
  hasHealth,
  loading,
  order,
}: Readonly<HealthProps>): ReactElement {
  const { clients } = useFilterContext();

  return (
    <HealthContainer
      style={{ order }}
    >
      {!hasHealth && !loading && (<UpgradeModule module="health" />)}
      <CurrentHealthContainer>
        <HealthUnitsInfo
          hasHealth={hasHealth}
          loading={loading}
        />
        <HealthHistoryCard
          hasHealth={hasHealth}
          loading={loading}
        />
      </CurrentHealthContainer>
      <HealthMap
        key={clients ? `health-map-${clients.join('-')}` : 'no-client'}
        loading={loading}
        hasHealth={hasHealth}
      />
    </HealthContainer>
  );
}

export const Health = memo(HealthComponent, (prev, next) => (
  prev.hasHealth === next.hasHealth
    && prev.loading === next.loading
    && prev.order === next.order
));
